import { ApiTag } from "../types/tags";
import ApiClient from "../client";

export const getTag = (client: ApiClient, tagId: string) => {
  return client.get<ApiTag>(`/tags/${tagId}`);
};

export const endpoints = {
  getTag,
};
